import React, { useContext } from "react";

import { LegacyCard as Card, DataTable, Link, InlineStack, Text } from "@shopify/polaris";
import { PrivateContext } from "lib/context";

import { fulfillmentsProp } from "app/orderLake/modules/operator/features/view/propsType";

const Fulfillments = (props) => {
  const { lineData } = props;
  const { cms } = useContext(PrivateContext);
  let fulfillments = lineData.map((item) => {
    const { productId } = item;
    if (item.trackingCompany || item.trackingNumber) {
      return [
        <InlineStack>
          <Link onClick={() => props.navigate(`/product-lake/edit/${productId}`)}>{item.name}</Link>,
          <Text as="h5">{item.trackingCompany}</Text>
,<Text as="h5">{item.trackingNumber}</Text>
        </InlineStack>,
      ];
    }
    return null;
  });

  fulfillments = fulfillments.filter((item) => item);
  return (
    <div className="add-ellipsis">
      <Card.Section subdued>
        <DataTable
          columnContentTypes={["text", "numeric", "numeric"]}
          headings={[cms("label.product"), cms("label.shippingCompany"), cms("label.trackingNumber")]}
          rows={fulfillments}
        />
      </Card.Section>
      <Card>
        <Card.Section>
          <InlineStack align="center">
            <Text as="span" fontWeight="semibold">
              Total Fulfilments
            </Text>
            <Text as="span" fontWeight="semibold">{`${fulfillments.length} of ${lineData.length}`}</Text>
          </InlineStack>
        </Card.Section>
      </Card>
    </div>
  );
};

Fulfillments.propTypes = fulfillmentsProp.type;

export default Fulfillments;
